// DEPENDENCIES
import React from 'react';
import SVGInline from "react-svg-inline"

// INNER IMPORTS
import lightnignsMugicsSVG from '../../inlineSVGs/lightnignsMugicsSVG';

import { clientMedia } from '../../../Config/Settings'


// style
import './ChooseCategory.css';
import { LIVE_MUSIC } from "../../../consts";
import tieMugicsSVG from "../../inlineSVGs/tieMugicsSVG";

const ChooseCategory = props => {
    const getCatTitle = () => {
        return props.type === LIVE_MUSIC ? `בחרו סוג מופע` : `בחרו קטגוריית שירות`
        // return ` Choose ${props.type === "service" ? "service category" : "show type"}`
    }

    return (
        <div className="chooseCategory rtl">
            <div className={"categoriesLogo " + props.type}>
                <SVGInline svg={props.type === LIVE_MUSIC ? lightnignsMugicsSVG : tieMugicsSVG} component="i" width="80px"/>
            </div>
            <div
                className={"title " + props.type + (props.userShouldEnter && props.userShouldEnter.indexOf("category") > -1 ? " required" : "")}
                style={{borderBottom: "1px solid rgb(198, 206, 210)"}}
            >
                {getCatTitle()}
            </div>
            <div className="categories" style={{borderRight: "1px solid rgb(198, 206, 210)"}}>
                {props.datatypes && props.datatypes.categories[props.type] ? props.datatypes.categories[props.type].map((category, index) => {
                    if (category.isHidden) return null;

                    return (
                        <div className={`category ${props.selectedCategory === category.name ? 'on' : ''}`}
                             key={index}
                             onClick={() => props.chooseSubmitCategory(category.name)}
                             style={{
                                 borderBottom: "2px solid rgb(198, 206, 210)",
                                 borderLeft: "1px solid rgb(198, 206, 210)"
                             }}
                        >
                            <label className={`cat-name`}>{category.text}</label>
                            <div className="on" style={{
                                backgroundImage: `url(${clientMedia()}/img/categoriesSubmit/${category.name}-on.svg)`,
                                visibility: (props.selectedCategory === category.name ? "visible" : "hidden")
                            }}></div>
                            <div className="off" style={{
                                backgroundImage: `url(${clientMedia()}/img/categoriesSubmit/${category.name}-off.svg)`,
                                visibility: (props.selectedCategory === category.name ? "hidden" : "visible")
                            }}></div>
                            <div className="hover" style={{
                                backgroundImage: `url(${clientMedia()}/img/categoriesSubmit/${category.name}-hover.svg)`,
                                visibility: (props.selectedCategory === category.name ? "hidden" : "visible")
                            }}></div>

                        </div>
                    )
                }) : null}
            </div>
        </div>
    )
};

export default ChooseCategory;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/ChooseCategory.js